import { ApiService } from '@1bill-app/services/api/api.service';
import { FaqQuery } from '@1bill-app/services/faq/faq.query';
import { FaqService } from '@1bill-app/services/faq/faq.service';
import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.page.html',
  styleUrls: ['./faq.page.scss'],
})
export class FaqPage implements OnInit {
  isLoading$ = this.faqQuery.isLoading$.pipe(map(res => res))
  faq$ = this.faqQuery.faqs$;
  constructor(
    public faqQuery: FaqQuery,
    public faqService: FaqService,
  ) { }

  ngOnInit() {
    this.faqService.getFaqCache().subscribe();
  }

}
